"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRevenueClause = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const demand_contracts_1 = require("../../demand-contracts");
const fake_key_value_pair_1 = require("./fake-key-value-pair");
faker_1.default.seed(718);
const costRevenueClause = (key) => ({
    cost: Number(faker_1.default.finance.amount()),
    key,
});
const percentRevenueClause = (key) => ({
    key,
    percent: Number(faker_1.default.finance.amount()),
});
const generateRevenueClause = (revenueClauseType) => {
    switch (revenueClauseType) {
        case demand_contracts_1.RevenueClauseType.CostPerUniqueSpecialOfferClickWithDynamicPayout:
        case demand_contracts_1.RevenueClauseType.LifeInsurancePolicyPayments:
        case demand_contracts_1.RevenueClauseType.OtherRevenue:
        case demand_contracts_1.RevenueClauseType.SavingsOfferClickPayout:
            return {
                key: revenueClauseType,
            };
        case demand_contracts_1.RevenueClauseType.CostPerCreditCardApproved:
        case demand_contracts_1.RevenueClauseType.CostPerFundedLoan:
        case demand_contracts_1.RevenueClauseType.CostPerLoanApproved:
        case demand_contracts_1.RevenueClauseType.CostPerLoanLenderQualifiedLead:
        case demand_contracts_1.RevenueClauseType.CostPerOtherConversion:
        case demand_contracts_1.RevenueClauseType.CostPerSavingsClick:
        case demand_contracts_1.RevenueClauseType.CostPerSavingsFunded:
        case demand_contracts_1.RevenueClauseType.CostPerSavingsOpened:
        case demand_contracts_1.RevenueClauseType.CostPerUniqueLoanClick15:
        case demand_contracts_1.RevenueClauseType.CostPerUniqueSavingsClick:
        case demand_contracts_1.RevenueClauseType.CostPerUniqueSpecialOfferClick:
            return costRevenueClause(revenueClauseType);
        case demand_contracts_1.RevenueClauseType.PercentGrossFundedLoanAmount:
        case demand_contracts_1.RevenueClauseType.PercentOriginationFee:
        case demand_contracts_1.RevenueClauseType.PercentOtherConversionAmount:
            return percentRevenueClause(revenueClauseType);
        case demand_contracts_1.RevenueClauseType.CostPerLoanFundedBySupplySubAccountId:
            return {
                costPerSupplySubAccountId: [
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)()), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()), totalReceivablePercent: Number(faker_1.default.finance.amount()) }),
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)()), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()), totalReceivablePercent: Number(faker_1.default.finance.amount()) }),
                ],
                defaultCost: faker_1.default.finance.amount(),
                flatFee: Number(faker_1.default.finance.amount()),
                key: revenueClauseType,
            };
        case demand_contracts_1.RevenueClauseType.CostPerSavingsOpenedBySupplySubAccountId:
        case demand_contracts_1.RevenueClauseType.CostPerUniqueOtherClickBySubAccountId:
            return Object.assign(Object.assign({}, costRevenueClause(revenueClauseType)), { costPerSupplySubAccountId: [
                    (0, fake_key_value_pair_1.generateKeyValuePair)(),
                    (0, fake_key_value_pair_1.generateKeyValuePair)(),
                ], defaultCost: faker_1.default.finance.amount(), flatFee: faker_1.default.finance.amount() });
        case demand_contracts_1.RevenueClauseType.CostPerUniqueSavingsClickByOfferId:
            return Object.assign(Object.assign({}, costRevenueClause(revenueClauseType)), { costPerOfferId: [
                    (0, fake_key_value_pair_1.generateKeyValuePair)(true),
                    (0, fake_key_value_pair_1.generateKeyValuePair)(true),
                ], flatFee: faker_1.default.finance.amount() });
        case demand_contracts_1.RevenueClauseType.PercentGrossFundedLoanAmountBySupply:
        case demand_contracts_1.RevenueClauseType.PercentOtherConversionAmountBySupplySubAccountId:
            return {
                basePercentage: faker_1.default.finance.amount(),
                key: revenueClauseType,
                percentBySupplySubAccountId: [
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)(true)), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()), totalReceivablePercent: Number(faker_1.default.finance.amount()) }),
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)(true)), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()), totalReceivablePercent: Number(faker_1.default.finance.amount()) }),
                ],
            };
        case demand_contracts_1.RevenueClauseType.PercentFundedLoanAmountWithThresholdMarginalPercentage:
            return {
                basePercent: Number(faker_1.default.finance.amount()),
                key: revenueClauseType,
                marginalPercent: Number(faker_1.default.finance.amount()),
                threshold: Number(faker_1.default.finance.amount()),
            };
        case demand_contracts_1.RevenueClauseType.PercentGrossFundedLoanAmountFlatFeeThreshold:
            return Object.assign(Object.assign({}, percentRevenueClause(revenueClauseType)), { flatFee: Number(faker_1.default.finance.amount()), threshold: Number(faker_1.default.finance.amount()) });
        case demand_contracts_1.RevenueClauseType.PercentFundedLoanAmountByFundedLoanAmountTier:
            return {
                key: revenueClauseType,
                maxPercent: Number(faker_1.default.finance.amount()),
                percentByFundedLoanAmount: [
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)()), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()) }),
                    Object.assign(Object.assign({}, (0, fake_key_value_pair_1.generateKeyValuePair)()), { demandPlatformFeePercent: Number(faker_1.default.finance.amount()) }),
                ],
            };
        default:
            return costRevenueClause(revenueClauseType);
    }
};
exports.generateRevenueClause = generateRevenueClause;
